import type { ReactNode } from "react";
import type { MeetingNoteSearchSnippet } from "@/hooks/useMeetingNoteSearch";

/** A search snippet's text with the found terms highlighted. */
export function SearchSnippet({
  snippet,
}: {
  snippet: MeetingNoteSearchSnippet;
}) {
  const { text, highlights } = snippet;
  const parts: ReactNode[] = [];
  let position = 0;
  for (const [start, end] of highlights) {
    parts.push(text.slice(position, start));
    parts.push(
      <mark key={start} className="rounded-sm bg-yellow-300 px-0.5 text-black">
        {text.slice(start, end)}
      </mark>,
    );
    position = end;
  }
  parts.push(text.slice(position));
  return <>{parts}</>;
}
